import React, { useEffect } from 'react';
import './paymentProcessing.css';
import { makePaymentPayNowApi } from '_services';
import toast from 'react-hot-toast';

const PaymentProcessingOffcanvas = ({ isOpen, message = "Please wait while we process your transaction..." ,paymentResult=()=>{},onClose }) => {

    // useEffect(()=>{
    //     setTimeout(()=>{
    //       paymentResult()
    //     },2000)
    // },[])

    useEffect(()=>{
       makepaymentHndale()
    },[isOpen])
    
 const makepaymentHndale = async()=>{

    const payload = {
      voucher_id:isOpen?.easebuzzDetails?._id,
      payment_mode:isOpen?.selectedMethod
    }

    try {
        const res = await makePaymentPayNowApi(payload)
        // console.log(res)
        if(res?.responseCode ==200){
            paymentResult({data:res?.data,voucher_id:isOpen?.easebuzzDetails?._id})
        }else{
            // toast.error("Server Error")
            onClose()
        }
    } catch (error) {
        
    }

 }

    return (
        <div>
            <div
                className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""}`}
                tabIndex={-1}
                style={{
                    visibility: isOpen ? "visible" : "hidden",
                }}
            >
                {isOpen && (
                    <div className="processing-offcanvas-body">
                        {/* Spinning Loader */}
                        <div className="processing-loader">
                            <div className="proccess_spinner"></div>
                        </div>

                        {/* Title */}
                        <h2 className="processing-title">Processing Payment</h2>

                        {/* Message */}
                        <p className="processing-message">{message}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PaymentProcessingOffcanvas;